import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import * as CHAVES from '../../constants/chaves';

const config = {
    apiKey: "AIzaSyB4ZwBwLTHIkdWnaYGxJLxDHRsThdRo2oc",
    authDomain: "expert-e8e8f.firebaseapp.com",
    databaseURL: "https://expert-e8e8f.firebaseio.com",
    projectId: "expert-e8e8f",
    storageBucket: "expert-e8e8f.appspot.com",
    messagingSenderId: "344570195322",
    appId: "1:344570195322:web:72e45f1f8704f5b7"
};
 
class Firebase {
    constructor() {
        app.initializeApp(config);
        this.auth = app.auth();
        this.db = app.database();

        this.googleProvider = new app.auth.GoogleAuthProvider();
        this.facebookProvider = new app.auth.FacebookAuthProvider();
    }

    // Autenticação
    doCreateUserWithEmailAndPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignInWithGoogle = () =>
        this.auth.signInWithPopup(this.googleProvider);

    doSignInWithFacebook = () =>
        this.auth.signInWithPopup(this.facebookProvider);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password =>
        this.auth.currentUser.updatePassword(password);

/*
    //usuarios 

    user = uid => this.db.ref(`Users/${uid}`);
    solicitante = uid => this.db.ref(`Solicitantes/${uid}`);

    users = () => this.db.ref('Solicitantes');

    cidades = () => this.db.ref('Cidades');

    areasDeAtuacao = () => this.db.ref('AreasDeAtuacao');

    abrirChamadoSolicitante = uidSolicitante => this.db.ref(`ChamadosPorSolicitanteEmAberto/${uidSolicitante}`);

    profissionaisPorCidadePorAreaAtuacao = () => this.db.ref('ProfissionaisPorCidadePorAreaAtuacao');

    chamadosPorProfissionalEmAndamento = () =>this.db.ref('ChamadosPorProfissionalEmAndamento');

    chamadosPorSolicitanteEmAberto = () => this.db.ref('ChamadosPorSolicitanteEmAberto');

    chamadosPorSolicitanteEmAndamento = () => this.db.ref('ChamadosPorSolicitanteEmAndamento');

    alertasPorUid = () => this.db.ref('AlertasPorUid');
*/
    

    // testes

    user = uid => this.db.ref(CHAVES.USERS`/${uid}`);
    solicitante = uid => this.db.ref(CHAVES.SOLICITANTES + `/${uid}`);

    users = () => this.db.ref(CHAVES.SOLICITANTES);

    cidades = () => this.db.ref(CHAVES.CIDADES);

    areasDeAtuacao = () => this.db.ref(CHAVES.AREAS_DE_ATUACAO);

    abrirChamadoSolicitante = uidSolicitante => this.db.ref(CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ABERTO+`/${uidSolicitante}`);

    chamadosPorSolicitanteEmAberto = () => this.db.ref(CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ABERTO);
    chamadosPorSolicitanteEmAnalise = () => this.db.ref(CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ANALISE);
    
    chamadosPorSolicitanteEmAndamento = () => this.db.ref(CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ANDAMENTO);
    chamadosPorSolicitenteFinalizados = () => this.db.ref(CHAVES.CHAMADOS_FINALIZADOS_POR_SOLICITANTE);

    profissionais = () => this.db.ref(CHAVES.PROFISSIONAIS);
    profissionaisPorCidadePorAreaAtuacao = () => this.db.ref(CHAVES.PROFISSIONAIS_CIDADES_ATUACAO);
    chamadosPorProfissionalEmAnalise = () =>this.db.ref(CHAVES.CHAMADOS_POR_PROFISSIONAL_EM_ANALISE);
    chamadosPorProfissionalFinalizados = () => this.db.ref(CHAVES.CHAMADOS_FINALIZADOS_POR_PROFISSIONAL);

    alertasPorUid = () => this.db.ref(CHAVES.ALERTA_POR_ID);
    
   
}

export default Firebase;